import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Events from './components/Events';
import About from './components/About';
import Services from './components/Services';
import Approach from './components/Approach';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import FAQSection from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LactanciaPreConsulta from './components/LactanciaPreConsulta';
import QuizzesIndex from './components/QuizzesIndex';
import Quiz from './components/Quiz';
import CursoLanding from './components/CursoLanding';
import CursoAula from './components/CursoAula';
import TallerPage from './components/TallerPage';
import AsesoriaLactancia from './components/lactancia/AsesoriaLactancia';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#F4EDE2] text-[#1F1B16] selection:bg-[#C97B5C]/30">
      <Header />
      <main>
        <Hero />
        <Events />
        <About />
        <Services />
        <Approach />
        <Testimonials />
        <Blog />
        <FAQSection />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#FAF4E8',
            color: '#2E2A23',
            border: '1px solid #DBCEB4',
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pre-consulta-lactancia" element={<LactanciaPreConsulta />} />
          <Route path="/quizzes" element={<QuizzesIndex />} />
          <Route path="/quizzes/:quizId" element={<Quiz />} />
          <Route path="/curso" element={<CursoLanding />} />
          <Route path="/curso/aula" element={<CursoAula />} />
          <Route path="/talleres/:slug" element={<TallerPage />} />
          <Route path="/asesoria" element={<AsesoriaLactancia />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
